module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-XBold.f2ab3d8b.woff";